import { ATTIO_STAGES_ATTRIBUTE_ID, ATTIO_VALUATIONS_OBJECT_ID } from 'common/constants/analyst-dashboards';
import { BaseAttioService } from './BaseAttioService';
import { AttioStatusOption, AttioStatusOptionsResponse, AttioUpdateValuationPayload } from '../attio.types';

// Service-specific types
export interface AttioStatusUpdateParams {
  valuationId: string;
  statusOptionId: string;
  valuationDetail?: Record<string, unknown>;
}

export class AttioStatusService extends BaseAttioService {
  constructor() {
    super('AttioStatusService');
  }
  /**
   * Get status options for valuations
   */
  async getValuationStatusOptions(): Promise<AttioStatusOption[]> {
    try {
      const rawData: AttioStatusOptionsResponse = await this.get(
        this.endpoints.retrieveStatusOptions(ATTIO_VALUATIONS_OBJECT_ID, ATTIO_STAGES_ATTRIBUTE_ID)
      );

      // Filter out archived options
      return rawData.data.filter(option => !option.is_archived);
    } catch (error) {
      console.error('Error fetching status options:', error);
      throw error;
    }
  }

  /**
   * Get status options for valuations (legacy function from attio-common.ts)
   */
  async getValuationStatusOptionsLegacy(): Promise<AttioStatusOption[]> {
    return this.getValuationStatusOptions();
  }

  /**
   * Update valuation status
   */
  async updateValuationStatus({ valuationId, statusOptionId, valuationDetail }: AttioStatusUpdateParams): Promise<void> {
    try {
      const payload: AttioUpdateValuationPayload = {
        data: {
          values: {
            stage: [
              {
                option: statusOptionId,
              },
            ],
          },
        },
      };

      await this.patch(this.endpoints.updateValuationByRecordId(valuationId), payload);
      await this.post(this.endpoints.triggerFulfillmentAssignmentAutomation(), {
        valuation_id: valuationId,
        new_stage_option_id: statusOptionId,
        valuation_detail: valuationDetail,
      });
    } catch (error) {
      console.error('Error updating valuation status:', error);
      throw error;
    }
  }

  /**
   * Check if a status is final (read-only)
   */
  isFinalStatus(status: string): boolean {
    const finalStatuses = ['Final Sent', 'Completed', 'Closed'];
    return finalStatuses.includes(status);
  }

  /**
   * Get status display information
   */
  getStatusDisplayInfo(status: string): { isFinal: boolean; canEdit: boolean } {
    const isFinal = this.isFinalStatus(status);
    return {
      isFinal,
      canEdit: !isFinal,
    };
  }
}
